import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useTranslation } from "react-i18next";
import { CustomSlider } from "~/utils/hooks/useSlider";

export const OpacitySlider = <TValue extends number | number[] = number>({
  setSliderValue,
  sliderValue,
  isPlanning = false,
  isDisabled = false,
}: {
  setSliderValue: React.Dispatch<TValue>;
  sliderValue: TValue;
  isPlanning?: boolean;
  isDisabled?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Box>
      <Typography>
        {!isPlanning
          ? t("projects:progress-opacity")
          : t("projects:planning-opacity")}
      </Typography>
      <CustomSlider
        // just type cast, bc too tired to make customslider accept generic types
        setSliderValue={setSliderValue as (value: number | number[]) => void}
        sliderValue={sliderValue}
        marks
        max={1}
        step={0.1}
        disabled={isDisabled}
      />
    </Box>
  );
};
